import React from 'react'
import clsx from 'clsx'

import useStyles from './styles'

const TypingIndicator = ({ names = [], numUsers, asMessage, onChat }) => {
  const classes = useStyles()

  const text = React.useMemo(() => {
    const otherCount = Math.max(numUsers - 1, 1)

    if (otherCount === 1 || names.length === 1) {
      return `${names[0]} is typing...`
    }

    if (names.length === 2) {
      return `${names.join(', ')} are typing...`
    }

    return 'People are typing...'
  }, [names, numUsers])

  return (
    <div
      className={clsx(
        classes.root,
        asMessage && classes.message,
        onChat && classes.onChat
      )}
    >
      {text}
    </div>
  )
}

export default TypingIndicator
